import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    balanceCard: {
      '&>.MuiCardContent-root': {
        padding: 0
      },
      '&>.MuiCardActions-root': {
        justifyContent: 'flex-end',
        padding: theme.spacing(2),
        paddingBottom: 0
      }
    }
  });
